var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancierDesktopLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 6.44043L10.9961 11.5504L20.1172 6.4704",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9961 20.61V11.54",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8419 1.48L3.28807 4.45003C2.02962 5.12003 1 6.80001 1 8.18001V13.83C1 15.21 2.02962 16.89 3.28807 17.56L8.8419 20.53C10.0275 21.16 11.9724 21.16 13.1581 20.53L18.7119 17.56C19.9704 16.89 21 15.21 21 13.83V8.18001C21 6.80001 19.9704 5.12003 18.7119 4.45003L13.1581 1.48C11.962 0.84 10.0275 0.84 8.8419 1.48Z",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1942 12.2396V8.57965L6.32422 3.09961",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancierDesktopLogoBlue);
export default __webpack_public_path__ + "static/media/financierDesktopLogoBlue.29f8a761d9ed4922871168d1d3f55f39.svg";
export { ForwardRef as ReactComponent };